'use strict';

module.exports = {
  'market-product-group': [{
    chartClassName: 'rmCompetitorFaresChart',
    type: 'competitor-fares-chart',
    label: 'Competitor Fares Profile',
    showIfFeature: 'COMPFARE_AVAILABILITY',
    visible: false,
    competitorMode: 'standalone'
  }, {
    chartClassName: 'rmProfileChart',
    type: 'profile-chart',
    brushFilterType: 'bookingProfile',
    label: 'Bookings Profile',
    visible: false
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-markets',
    brushFilterType: 'markets',
    label: 'Market',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-seasons',
    brushFilterType: 'seasons',
    label: 'Demand Season',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-class-groups',
    brushFilterType: 'classGroups',
    label: 'Product Group',
    preLabel: 'Product Grp ',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-any-dow',
    brushFilterType: 'dow',
    label: 'Day of Week',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-pos',
    brushFilterType: 'pos',
    label: 'Point of Sale',
    showIfFeature: 'SPOS',
    size: 'medium',
    visible: true
  }],
  'market': [{
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-markets',
    brushFilterType: 'markets',
    label: 'Market',
    size: 'small',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-any-dow',
    brushFilterType: 'dow',
    label: 'Day of Week',
    size: 'medium',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-market-pos',
    brushFilterType: 'pos',
    label: 'Point of Sale',
    showIfFeature: 'SPOS',
    size: 'medium',
    visible: true
  }],
  'service': [{
    chartClassName: 'rmCompetitorFaresChart',
    type: 'competitor-fares-chart',
    label: 'Competitor Fares Profile',
    showIfFeature: 'COMPFARE_AVAILABILITY',
    visible: false,
    competitorMode: 'standalone'
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-service-time-of-day',
    brushFilterType: 'timeOfDay',
    label: 'Time of Day',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-service-number-of-stops',
    brushFilterType: 'numberOfStops',
    label: 'No of Stops',
    preLabel: 'No. of Stops - ',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-service-classes',
    brushFilterType: 'class',
    label: 'Class',
    preLabel: 'Class ',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-any-dow',
    brushFilterType: 'serviceDow',
    label: 'Day of Week',
    visible: true
  }, {
    chartClassName: 'rmThematicMarketChart',
    type: 'thematic-demand-chart-service-pos',
    brushFilterType: 'pos',
    label: 'Point of Sale',
    showIfFeature: 'SPOS',
    size: 'medium',
    visible: true
  }]
};